/*
 * Copyright © 2023 Broadcom. All rights reserved. The term “Broadcom” refers to Broadcom Inc. and/or its subsidiaries. All trademarks, trade names, service marks, and logos referenced herein belong to their respective companies.
 * This software and all information contained therein is confidential and proprietary and shall not be duplicated, used, disclosed or disseminated in any way except as authorized by the applicable license agreement, without the express written permission of Broadcom. All authorized reproductions must be marked with this language.
 * EXCEPT AS SET FORTH IN THE APPLICABLE LICENSE AGREEMENT, TO THE EXTENT PERMITTED BY APPLICABLE LAW OR AS AGREED BY BROADCOM IN ITS APPLICABLE LICENSE AGREEMENT, BROADCOM PROVIDES THIS DOCUMENTATION “AS IS” WITHOUT WARRANTY OF ANY KIND, INCLUDING WITHOUT LIMITATION, ANY IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, OR NONINFRINGEMENT. IN NO EVENT WILL BROADCOM BE LIABLE TO THE END USER OR ANY THIRD PARTY FOR ANY LOSS OR DAMAGE, DIRECT OR INDIRECT, FROM THE USE OF THIS DOCUMENTATION, INCLUDING WITHOUT LIMITATION, LOST PROFITS, LOST INVESTMENT, BUSINESS INTERRUPTION, GOODWILL, OR LOST DATA, EVEN IF BROADCOM IS EXPRESSLY ADVISED IN ADVANCE OF THE POSSIBILITY OF SUCH LOSS OR DAMAGE.
 */
import React, { Component } from "react";

import {
  Box, Button
} from "@mineral/core";


import AccessibleTooltip from './../common/AccessibleTooltip';
export default class NameColumnCellRendererInterfacesTable extends Component {


  handleTableClick() {
    this.props.context.handleDrillDown(this.props);
  }


  render() {
    let valueProp = this.props.data.displayName;
    let view = (
      <div style={{ display: "flex" }} tabIndex={-1}>


        <Button role="link" disableRipple={true} style={{display:'flex',justifyContent:'flex-start'}}
                className="mcsdashboard-transparent-btn"
                onClick={this.handleTableClick.bind(this)}
                aria-roledescription={"Click to view details"}
                >
                {/*<span style={{color:"#3272D9"}}> {this.props.data && this.props.data.name?this.props.data.name:""}</span>*/}
                <AccessibleTooltip title={valueProp?valueProp:""}>
      <Box component={'span'} style={{ overflow: 'hidden',color:"#3272D9", whiteSpace: 'nowrap', textOverflow: 'ellipsis' ,textTransform:'none'}}>
     { valueProp!==null && valueProp!==undefined?valueProp:''}
      </Box>
    </AccessibleTooltip>
                </Button>
        </div>
       )

    return view;
  }
}


